import { gql } from "@apollo/client";

export type FetchLatestUpdatesQueryVariables = Record<string, never>;

export type FetchLatestUpdatesQuery = {
  __typename?: "Query";
  fetchLatestUpdates?: Array<{
    __typename?: "LatestUpdate";
    documentId: string;
    title: string;
    text: string;
    startDate: string;
    endDate: string;
    link?: {
      __typename?: "ComponentCommonLink";
      text: string;
      url?: string | null;
    } | null;
  }> | null;
};

export const QUERY_FETCH_LATEST_UPDATES = gql`
  query FetchLatestUpdates {
    fetchLatestUpdates {
      documentId
      title
      text
      startDate
      endDate
      link {
        text
        url
      }
    }
  }
`;
